import { routes } from './locais.routes';
import AtvLocaisListController from "./directory/directory.controller";
import AtvLocaisDetailsController from "./details/details.controller";
export default angular.module('app.ativos.locais', [])
    .config(routes)
    .controller('AtvLocaisListController', AtvLocaisListController)
    .controller('AtvLocaisDetailsController', AtvLocaisDetailsController)
    .name;
